import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GiftCardsState } from '../types'

import { fetchGiftCardAddon } from './giftCardsThunks'

const initialState: GiftCardsState = {
  giftCardAddon: null,
  giftCardAddonOutlet: null,
  isGiftCardCheckoutWarningModalVisible: false,
}

const giftCardsSlice = createSlice({
  name: 'giftCards',
  initialState,
  reducers: {
    setGiftCardCheckoutWarningModalVisible(
      state: GiftCardsState,
      action: PayloadAction<boolean>,
    ) {
      state.isGiftCardCheckoutWarningModalVisible = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchGiftCardAddon.pending, state => {
        state.giftCardAddon = null
        state.giftCardAddonOutlet = null
      })
      .addCase(fetchGiftCardAddon.fulfilled, (state, action) => {
        state.giftCardAddon = action.payload.giftCardAddOn
        state.giftCardAddonOutlet = action.payload.outlet
      })
  },
})

export const { setGiftCardCheckoutWarningModalVisible } = giftCardsSlice.actions

export default giftCardsSlice.reducer
